//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// event-summary
import * as s from "./CardTopLine.styles";
// state
import { IReduxState } from "@reducers/root.reducer";
// util
import { getRelativeTime } from "@clockwise/client-commons/src/util/format-time";
import { ZonedMoment } from "@util/time-zone.util";
// material-ui
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { Clear } from "@material-ui/icons";

//////////////////
// TYPEs
//////////////////
interface IContainer {
  label: string;
  timeStamp?: string;
  clear?: () => void;
}

interface IProps extends IContainer, WithStyles<typeof s.styles> {
  lastViewedFeedMillis: number;
}

//////////////////
// COMPONENT
//////////////////
class CardTopLineComponent extends React.Component<IProps> {
  public render() {
    const { clear, label, timeStamp } = this.props;
    const timeStampMoment = new ZonedMoment(timeStamp);
    // const isNew = (this.props.lastViewedFeedMillis - timeStampMoment.valueOf()) < (3 * 60000);
    const isNew = this.props.lastViewedFeedMillis < timeStampMoment.valueOf() + 10 * 60 * 1000; // show 'new' if the user hasn't seen the feed yet + buy 10 min
    const relativeTime = getRelativeTime(timeStampMoment);

    return (
      <div style={s.toplineNew}>
        <div style={s.metaInfo}>
          <div>{label}</div>
          {!!timeStamp && <div style={s.interpunct}>&middot;</div>}
          {!!timeStamp && (
            <React.Fragment>
              <div>{relativeTime}</div>
              {isNew ? <div style={s.interpunct}>&middot;</div> : null}
            </React.Fragment>
          )}
          {!!timeStamp && isNew && <div style={s.newText}>New</div>}
        </div>
        {!!clear && <Clear className={this.props.classes.icon} onClick={() => clear()} />}
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    lastViewedFeedMillis: state.chromeFeed.lastViewedFeedMillis,
  };
}

const reduxContainer = connect(mapStateToProps, {})(CardTopLineComponent);

export const CardTopLine = withStyles(s.styles)(reduxContainer);
